import { Icon, Typography } from "@platform/design-system";
import { Stack } from "@mui/material";

import type { EventSummary } from "../../messageSummary";

export interface EventRowProps {
  event: EventSummary;
}

/**
 * Something that happened to the thread which nobody wrote.
 *
 * Quieter than a message and deliberately not shaped like one: an
 * out-of-office drawn as a reply reads as the carrier answering, which is the
 * mistake ADR 10.42 keeps these out of the messages table to avoid. It still
 * has to be visible — a reader has to see that the bounce came back — so it
 * sits in position rather than in a separate list.
 */
export const EventRow = ({ event }: EventRowProps): React.JSX.Element => (
  <Stack
    data-testid="event-row"
    data-event-id={event.id}
    direction="row"
    alignItems="center"
    spacing={1}
    sx={{ px: 2, py: 1 }}
  >
    <Icon
      name={event.isProblem ? "warning" : "info"}
      size="sm"
      color={event.isProblem ? "warning" : "muted"}
    />

    <Typography
      data-testid="event-row-label"
      variant="caption"
      color="textSecondary"
      sx={{ flexGrow: 1 }}
    >
      {event.label}
    </Typography>

    <Typography
      data-testid="event-row-time"
      variant="caption"
      color="textSecondary"
    >
      {event.at}
    </Typography>
  </Stack>
);
